"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetScolapassPayments = void 0;
class GetScolapassPayments {
    constructor(userRepository) {
        this.userRepository = userRepository;
    }
    execute(request, callback) {
        return this.userRepository.getScolapassPayments(request, callback);
    }
}
exports.GetScolapassPayments = GetScolapassPayments;
